<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [value]="facturas" [columns]="cols" dataKey="id"
                     selectionMode="multiple" [(selection)]="facturasSeleccionados"
                     [rowHover]="true" [rows]="10" [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['secuencial','subjectFullName','resumen']"
                     sortMode="multiple" [multiSortMeta]="multiSortMeta"
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <span class="p-input-icon-left ml-1 w-full mr-2">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."
                                   class="w-full"/>
                        </span>
                        <p-button id="notification-button" 
                                  pTooltip="Ver totales" tooltipPosition="bottom" 
                                  styleClass="p-button-text p-button-sm"
                                  (click)="verTotalesFacturas($event, 'main')">
                            <ng-template pTemplate="content">
                                <img alt="bug" src="assets/layout/icons/dollar.png" style="width: 2rem" />
                                <span *ngIf="!enabledTotals" id="notification-note">/</span>
                            </ng-template>
                        </p-button>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible" [ngClass]="col.class">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </div>
                    </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td style="width: 3rem">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                        <span *ngIf="col.field != 'isPayment'"> {{col.field == 'importeTotal' ? ('$'+rowData[col.field].toFixed(2)) :  rowData[col.field]}}</span>
                    </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td>{{appConfig.ux.emptyMsg}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>